import React from 'react';

// Custom wallet icon matching Feather Icons style (24x24, stroke-width 2, round caps/joins)
const WalletIcon = ({ size = 22, color = 'currentColor', style = {} }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ flexShrink: 0, ...style }}
  >
    {/* Wallet body */}
    <rect x="2" y="5" width="20" height="14" rx="2" />
    {/* Inner card slot divider */}
    <path d="M2 10h20" />
    {/* Coin */}
    <circle cx="16" cy="15.5" r="2" />
  </svg>
);

export default WalletIcon;
